import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const FaqWrapper = createComponent('div', {
  className:
    'mx-20 mb-[96px] mt-48 flex flex-col items-center justify-center bg-grey-1'
});

export const FaqTitle = createComponent('h2', {
  className: cx(
    'mb-28 mt-12 sm:mb-32',
    'text-[24px] font-bold leading-[28px] text-blue-6 sm:tl-header-xl md:tl-header-xxl'
  )
});

export const QuestionAndResponseWrapper = createComponent('div', {
  className: 'w-4/5 min-w-[300px] border-b border-grey-2 p-20'
});

export const QuestionAndResponseTitle = createComponent('h3', {
  className: 'relative mb-8 pr-[2rem] text-blue-6 tl-header-s'
});

export const Response = createComponent('p', {
  className: 'text-[#757989]'
});
